import { render, staticRenderFns } from "./ListadoKits.vue?vue&type=template&id=286f32e2&scoped=true"
import script from "./ListadoKits.vue?vue&type=script&lang=js"
export * from "./ListadoKits.vue?vue&type=script&lang=js"
import style0 from "./ListadoKits.vue?vue&type=style&index=0&id=286f32e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286f32e2",
  null
  
)

export default component.exports